<template>
  <div class="public-layout" :class="{ 'is-kiosk': isKiosk }">
    <div class="public-content">
      <router-view />
    </div>
    <nav v-if="!isKiosk" class="bottom-nav">
      <router-link to="/" class="nav-item" exact-active-class="active">
        <i class="el-icon-s-home"></i>
        <span>首页</span>
      </router-link>
      <router-link to="/checkin" class="nav-item" active-class="active">
        <i class="el-icon-camera"></i>
        <span>刷脸签到</span>
      </router-link>
      <router-link to="/records" class="nav-item" active-class="active">
        <i class="el-icon-document"></i>
        <span>我的课时</span>
      </router-link>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'PublicLayout',
  computed: {
    isKiosk() {
      return !!(this.$route.meta && this.$route.meta.kiosk)
    }
  }
}
</script>

<style scoped>
.public-layout {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: calc(56px + env(safe-area-inset-bottom));
}
.public-layout.is-kiosk {
  padding-bottom: env(safe-area-inset-bottom);
}
.public-content {
  max-width: 640px;
  margin: 0 auto;
  padding: 16px;
}
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 56px;
  padding-bottom: env(safe-area-inset-bottom);
  background: #fff;
  border-top: 1px solid #eee;
  display: flex;
  z-index: 100;
  max-width: 640px;
  margin: 0 auto;
}
.nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999;
  text-decoration: none;
  font-size: 11px;
  gap: 2px;
}
.nav-item i { font-size: 22px; }
.nav-item.active { color: #409EFF; }
@media (min-width: 641px) {
  .bottom-nav {
    left: 50%;
    transform: translateX(-50%);
    border-left: 1px solid #eee;
    border-right: 1px solid #eee;
  }
}
</style>
